/***** Tests set Live */
class MobileStickyATC {
    constructor() {
        this.stickyContainer = null;
        this.mainATC = document.querySelector('form[action="/cart/add"] [name="add"]');

        if (!this.mainATC) return;

        this.init();
    }

    init() {
        this.setupEventListeners();
        this.handleScroll();
    }

    getCurrentPrice() {
        const priceElem = document.querySelector('[data-product-price]') || document.querySelector('.product__price');
        if (!priceElem) return '';
        let price = priceElem.innerText.replace(/[^0-9.]/g, '');
        if (price && !price.includes('.')) price += '.00';
        else if (price && price.split('.')[1].length === 1) price += '0';
        return `$${price}`;
    }

    getCurrentVariantName() {
        const checkedInput = document.querySelector('.variant-input input:checked + label');
        return checkedInput ? checkedInput.innerText : '';
    }

    setupEventListeners() {
        this.stickyContainer = document.querySelector('.lpg-sticky-atc') 
        if (!this.stickyContainer) return;

        this.stickyContainer.querySelector('.sticky-atc-btn')?.addEventListener('click', () => {
            this.mainATC.click();
        });

        window.addEventListener('scroll', () => this.handleScroll());

        // Update on variant change
        document.querySelectorAll('.variant-input input').forEach(input => {
            input.addEventListener('change', () => {
                setTimeout(() => this.updateStickyBar(), 100);
            });
        });

        // Update on price changes
        const priceElem = document.querySelector('[data-product-price]') || document.querySelector('.product__price');
        if (priceElem) {
            const observer = new MutationObserver(() => this.updateStickyBar());
            observer.observe(priceElem, { childList: true, characterData: true, subtree: true });
        }

        // Update on loading state changes
        if (this.mainATC) {
            const stateObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && (mutation.attributeName === 'aria-disabled' || mutation.attributeName === 'disabled')) {
                        this.syncLoadingState();
                    }
                });
            });
            stateObserver.observe(this.mainATC, { attributes: true });
            this.syncLoadingState(); // Initial check
        }
    }

    syncLoadingState() {
        if (!this.mainATC || !this.stickyContainer) return;

        const isLoading = this.mainATC.getAttribute('aria-disabled') === 'true' || this.mainATC.hasAttribute('disabled');
        const stickyBtn = this.stickyContainer.querySelector('.sticky-atc-btn');
        if (stickyBtn) {
            if (isLoading) {
                stickyBtn.classList.add('is-loading');
                stickyBtn.setAttribute('disabled', 'disabled');
            } else {
                stickyBtn.classList.remove('is-loading');
                stickyBtn.removeAttribute('disabled');
            }
        }
    }

    updateStickyBar() {
        const currentPrice = this.getCurrentPrice();
        const currentVariant = this.getCurrentVariantName();

        const btnText = this.stickyContainer?.querySelector('.sticky-btn-text');
        if (btnText) btnText.innerText = `Add to cart - ${currentPrice}`;

        const variantNameElem = this.stickyContainer?.querySelector('.sticky-variant-name');
        if (variantNameElem) variantNameElem.innerText = currentVariant;

        const imageElem = this.stickyContainer?.querySelector('.sticky-product-image');
        if (imageElem) {
            const mainImage = document.querySelector('.product-image-main img');
            if (mainImage) {
                imageElem.src = mainImage.src || '';
                imageElem.srcset = mainImage.srcset || '';
            }
        }
    }

    handleScroll() {
        if (!this.mainATC || !this.stickyContainer) return;

        const rect = this.mainATC.getBoundingClientRect();
        const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

        if (!isVisible && rect.top < 0) {
            this.stickyContainer.classList.add('is-visible');
        } else {
            this.stickyContainer.classList.remove('is-visible');
        }
    }
}

new MobileStickyATC();

/***** Tests set Live End */



/*** Test Product Page **/
if(document.querySelector('.test-2-variant-1')){
    const elem = document.querySelector('[data-product-photos]');
    const flkty = Flickity.data(elem);

    // Resize image to left
    flkty.options.cellAlign = 'left';
    flkty.resize();

    window.handleSlideChangeThumbnailMove = (productContainer)=>{
        // This function will move the thumbnails if needed:
        if (!productContainer) return;

        const selectedThumbnail = productContainer.querySelector('.product__thumb.is-active');
        const thumbnailScroll = productContainer.querySelector('[data-product-thumbs] .product__thumbs--scroller');

        if (!thumbnailScroll || !selectedThumbnail) return;

        const thumbRect = selectedThumbnail.getBoundingClientRect();
        const containerRect = thumbnailScroll.getBoundingClientRect();

        const thumbCenter = thumbRect.left + thumbRect.width / 2;
        const containerCenter = containerRect.left + containerRect.width / 2;

        const scrollAdjustment = thumbCenter - containerCenter;

        thumbnailScroll.scrollBy({
            left: scrollAdjustment,
            behavior: "smooth"
        });
    }
}

/*** Test Product Page End**/


/**** Test 6 Cart : Done ***********/
class CartDrawerChanges {
    constructor(cartDrawer) {
        this.cartDrawer = cartDrawer;
        this.debounceTimer = null; 
        
        this.init();
        
        this.setupObserver();
    }


    init() {
        this.cartFooter = this.cartDrawer.querySelector('.unicorn_cart_footer .unicorn_cart_block');
        this.cartCheckoutBtn = this.cartDrawer.querySelector('#unicorn_checkout_submit');

        this.createNewFooter();
        this.modifyCheckoutBtn();
    }


    debounce(callback, delay) {
        return (...args) => {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => callback.apply(this, args), delay);
        };
    }

    setupObserver() {
        this.observer = new MutationObserver(this.debounce((mutations) => {
            const isExternalMutation = mutations.some(mutation => {
                return !mutation.target.closest('.madd-gear-changes__cart-footer');
            });

            if (isExternalMutation) {
                this.handleCartUpdate();
            }
        }, 300));

        this.startObserver();
    }

    startObserver() {
        if (this.cartDrawer) {
            this.observer.observe(this.cartDrawer, { childList: true, subtree: true, characterData: true });
        }
    }

    handleCartUpdate() {
        this.observer.disconnect();
        this.init();
        this.startObserver();
    }

    formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
    }

    modifyCheckoutBtn() {
        if (!this.cartCheckoutBtn) return;

        const btnText = this.cartCheckoutBtn.querySelector('.unicorn_cart_checkout_button_text');
        if (!btnText) return;
        if (btnText.querySelector('svg')) return; 
        btnText.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" fill="white" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" fill="black"/>
                <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Secure Checkout</span>`;
    }

    detailsTrigger() {
        const trigger = this.cartDrawer.querySelector('#detailsTrigger');
        const wrapper = this.cartDrawer.querySelector('#detailsWrapper');

        if (trigger && wrapper) {
            const isOpen = wrapper.classList.toggle('is-open');
            trigger.textContent = isOpen ? 'Hide Details' : 'Show Details';
        }
    }

    createNewFooter() {
        if (!this.cartFooter) return;
        const existingFooter = this.cartFooter.querySelector('.madd-gear-changes__cart-footer');
        if (existingFooter) {
            existingFooter.remove();
        }

        const finalTotalValue = unicornCartData.totalPrice.value; 
        const savingsValue = unicornCartData.totalSavings.totalWithCompareAtPrice.value; 
        const subtotalValue = finalTotalValue + savingsValue; 
        
        const savingsAmountFormatted = this.formatMoney(savingsValue);
        const savingsAmountBadge = savingsAmountFormatted.replace('.00', '');

        const div = document.createElement('div');
        div.classList.add('madd-gear-changes__cart-footer'); 
        
        div.innerHTML = `
            <div class="madd-gear-changes__details-wrapper" id="detailsWrapper">
                <div class="madd-gear-changes__subtotal-details-container">
                    <div class="detail-row">
                        <span>Subtotal</span>
                        <span class='madd-gear-changes__subtotal-value'>${this.formatMoney(subtotalValue)}</span>
                    </div>
                    <div class="detail-row">
                        <span>Discount</span>
                        <span class="discount-text">-${savingsAmountFormatted}</span>
                    </div>
                    <div class="detail-row">
                        <span>Shipping &amp; Taxes</span>
                        <span class="muted-text">Calculated At Checkout</span>
                    </div>
                    <hr class="detail-line">
                </div>
            </div>
            <div class="madd-gear-changes__subtotal-container">
                <p class="madd-gear-changes__subtotal-text">Total</p>
                <div class="madd-gear-changes__pricing-container">
                    ${savingsValue > 0 ? `<span class="price-badge">${savingsAmountBadge} Off</span>` : ''}
                    ${savingsValue > 0 ? `<span class="price-crossed">${this.formatMoney(subtotalValue)}</span>` : ''}
                    <span class="price-final"><b>${unicornCartData.totalPrice.money}</b></span>
                </div>
            </div>
            <button class="madd-gear-changes__details-trigger" id="detailsTrigger">Show Details</button>
        `;
            
        this.cartFooter.appendChild(div);

        const btn = div.querySelector('.madd-gear-changes__details-trigger');
        if (btn) {
            btn.addEventListener('click', this.detailsTrigger.bind(this));
        }
    }
}

// Initialization logic remains exactly the same
// const isTest6 = document.querySelector('.test-6-variant-1');
// if (isTest6) {
    const checkUnicorn = setInterval(() => {
        if (typeof unicornCartData != 'undefined' && document.querySelector('#unicorn-cart-dialog')) {
            clearInterval(checkUnicorn);
            new CartDrawerChanges(document.querySelector('#unicorn-cart-dialog'));
        }
    }, 500);
// }
/**** Test 6 Cart End : Done  ******/





/***** Test 8 PDP First Viewport ******/
class PDPFirstViewport8 {
    constructor() {
        this.variant1 = document.querySelector('.test-8-variant-1');
        this.variant2 = document.querySelector('.test-8-variant-2');
        this.variant3 = document.querySelector('.test-8-variant-3');

        this.init();
    }

    init() {
        this.renderBenefitsGrid();

        // Only beenfit needed, remove all else
        // if (this.variant1 || this.variant3) {
        //     this.handleLayoutShifts();
        //     this.replaceBreadcrumbDividers();
        // }

        // if (this.variant1) {
        //     this.initEnhancedGallery();
        //     if (window.innerWidth > 768) {
        //         this.initDesktopThumbnails();
        //     }
        // }
    }

    replaceBreadcrumbDividers() {
        const dividers = document.querySelectorAll('.breadcrumb__divider');
        if (dividers.length === 0) return;

        const svgIcon = `
           <svg xmlns="http://www.w3.org/2000/svg" width="7" height="6" viewBox="0 0 7 6" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.3182 2.51419C6.49394 2.67894 6.49394 2.94606 6.3182 3.11081L3.76819 5.50144C3.59246 5.66619 3.30753 5.66619 3.1318 5.50144C2.95606 5.33668 2.95606 5.06957 3.1318 4.90481L5.36361 2.8125L3.1318 0.720193C2.95606 0.555433 2.95606 0.288323 3.1318 0.123562C3.30753 -0.0411875 3.59246 -0.0411875 3.76819 0.123562L6.3182 2.51419ZM0.768195 0.123562L3.3182 2.51419C3.49394 2.67894 3.49394 2.94606 3.3182 3.11081L0.768195 5.50144C0.592465 5.66619 0.307535 5.66619 0.131805 5.50144C-0.043935 5.33668 -0.043935 5.06957 0.131805 4.90481L2.3636 2.8125L0.131805 0.720193C-0.043935 0.555433 -0.043935 0.288323 0.131805 0.123562C0.307535 -0.0411875 0.592465 -0.0411875 0.768195 0.123562Z" fill="#6A6A6A"/>
            </svg>
        `;

        dividers.forEach(divider => {
            if (!divider.dataset.breadcrumbModified) {
                divider.innerHTML = svgIcon;
                divider.dataset.breadcrumbModified = "true";
            }
        });
    }

    renderBenefitsGrid() {
        const paymentButtons = document.querySelector('.product-single__form .payment-buttons');
        const restockBtn = document.querySelector('.restock-rocket-button-container')
        if (!paymentButtons || document.querySelector('.test-8-benefits')) return;

        const benefitsHtml = `
            <div class="test-8-benefits">
                <div class="test-8-benefit-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="30" viewBox="0 0 35 30" fill="none">
                        <path d="M9 15C9 16.6811 9.49852 18.3245 10.4325 19.7223C11.3665 21.1202 12.694 22.2096 14.2472 22.853C15.8004 23.4963 17.5094 23.6646 19.1583 23.3367C20.8071 23.0087 22.3217 22.1991 23.5104 21.0104C24.6991 19.8217 25.5087 18.3071 25.8367 16.6583C26.1646 15.0094 25.9963 13.3004 25.353 11.7472C24.7096 10.194 23.6202 8.8665 22.2223 7.93251C20.8245 6.99852 19.1811 6.5 17.5 6.5C15.1237 6.50894 12.8429 7.43616 11.1344 9.08778L9 11.2222" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9 6.5V11.5H14" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                    <span>14 Day<br>Returns</span>
                </div>
                <div class="test-8-benefit-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="24" viewBox="0 0 35 24" fill="none">
                        <path d="M25.5 5H9.5C8.39543 5 7.5 5.89543 7.5 7V17C7.5 18.1046 8.39543 19 9.5 19H25.5C26.6046 19 27.5 18.1046 27.5 17V7C27.5 5.89543 26.6046 5 25.5 5Z" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.5 10H27.5" stroke="#0A0A0A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Secure<br>Payment</span>
                </div>
                <div class="test-8-benefit-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="24" viewBox="0 0 35 24" fill="none">
                        <path d="M25.5 12.9487C25.5 17.6979 22 20.0725 17.84 21.4498C17.6222 21.5199 17.3855 21.5165 17.17 21.4403C13 20.0725 9.5 17.6979 9.5 12.9487V6.29979C9.5 6.04788 9.60536 5.80628 9.79289 5.62815C9.98043 5.45002 10.2348 5.34995 10.5 5.34995C12.5 5.34995 15 4.21014 16.74 2.76638C16.9519 2.59446 17.2214 2.5 17.5 2.5C17.7786 2.5 18.0481 2.59446 18.26 2.76638C20.01 4.21964 22.5 5.34995 24.5 5.34995C24.7652 5.34995 25.0196 5.45002 25.2071 5.62815C25.3946 5.80628 25.5 6.04788 25.5 6.29979V12.9487Z" stroke="#0A0A0A" stroke-width="1.18799" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.5 11.5L16.8333 13.5L21.5 9.5" stroke="#0A0A0A" stroke-width="1.18799" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>2-Year<br>Warranty</span>
                </div>
            </div>
        `;
        if (restockBtn) restockBtn.insertAdjacentHTML('afterend', benefitsHtml);
        else
            paymentButtons.insertAdjacentHTML('afterend', benefitsHtml);
    }

    handleLayoutShifts() {
        // Move reviews above title on mobile
        const reviewSummary = document.querySelector('.product-single__meta .yotpo-widget-instance') || document.querySelector('.yotpo-widget-instance');
        const productTitle = document.querySelector('.product-single__title');

        if (window.innerWidth <= 768 && reviewSummary && productTitle) {
            productTitle.parentNode.insertBefore(reviewSummary, productTitle);
        }
    }

    initEnhancedGallery() {
        // Standard Test 2 thumbnails logic handled by CSS and theme.js
        // Custom arrows and save XX badge will be added here
        this.addGalleryArrows();
    }

    addGalleryArrows() {
        const photosContainer = document.querySelector('[data-product-photos]');
        if (!photosContainer || photosContainer.querySelector('.test-8-gallery-arrow')) return;

        const leftArrow = document.createElement('button');
        leftArrow.className = 'test-8-gallery-arrow is-left';
        leftArrow.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
        <path d="M2.30001 8.70002L8.30001 14.6C8.70001 15 9.40001 15 9.80001 14.6C10.2 14.2 10.2 13.5 9.80001 13.1L4.50001 8.00002L9.70001 2.80002C10.1 2.40003 10.1 1.70002 9.70001 1.30002C9.30001 0.900025 8.60001 0.900025 8.20001 1.30002L2.20001 7.30002C1.90001 7.70002 1.90001 8.30002 2.30001 8.70002Z" fill="white"/>
        </svg>
        `;

        const rightArrow = document.createElement('button');
        rightArrow.className = 'test-8-gallery-arrow is-right';
        rightArrow.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
                <path d="M9.70002 7.29998L3.70002 1.39998C3.30002 0.999976 2.60002 0.999976 2.20002 1.39998C1.80002 1.79998 1.80002 2.49998 2.20002 2.89998L7.50002 7.99998L2.30002 13.2C1.90002 13.6 1.90002 14.3 2.30002 14.7C2.70002 15.1 3.40002 15.1 3.80002 14.7L9.80002 8.69998C10.1 8.29998 10.1 7.69998 9.70002 7.29998Z" fill="white"/>
            </svg>
        `;

        photosContainer.appendChild(leftArrow);
        photosContainer.appendChild(rightArrow);

        const flkty = Flickity.data(photosContainer);
        if (flkty) {
            leftArrow.addEventListener('click', () => flkty.previous());
            rightArrow.addEventListener('click', () => flkty.next());

            const updateArrows = () => {
                leftArrow.style.opacity = flkty.selectedIndex === 0 ? '0.4' : '1';
                rightArrow.style.opacity = flkty.selectedIndex === flkty.cells.length - 1 ? '0.4' : '1';
            };

            flkty.on('select', updateArrows);
            updateArrows();
        }
    }

    initDesktopThumbnails() {
        const thumbScroller = document.querySelector('.product__thumbs--scroller');
        const mainPhotos = document.querySelector('[data-product-photos]');
        if (!thumbScroller || !mainPhotos) return;

        // Sync height
        const syncHeight = () => {
            thumbScroller.style.maxHeight = `${mainPhotos.offsetHeight}px`;
        };
        syncHeight();
        window.addEventListener('resize', syncHeight);

        // Add arrows
        if (thumbScroller.querySelector('.test-8-thumb-arrow')) return;

        // Use theme's chevron SVG for arrows
        const chevronSvg = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg>`;

        const topArrow = document.createElement('button');
        topArrow.className = 'test-8-thumb-arrow is-top';
        topArrow.innerHTML = chevronSvg;
        topArrow.style.transform = 'rotate(180deg)';

        const bottomArrow = document.createElement('button');
        bottomArrow.className = 'test-8-thumb-arrow is-bottom';
        bottomArrow.innerHTML = chevronSvg;

        thumbScroller.parentNode.insertBefore(topArrow, thumbScroller);
        thumbScroller.parentNode.appendChild(bottomArrow);

        const updateThumbArrows = () => {
            const isAtTop = thumbScroller.scrollTop <= 5;
            const isAtBottom = Math.ceil(thumbScroller.scrollTop + thumbScroller.clientHeight) >= thumbScroller.scrollHeight - 5;

            // Only show arrows if scrolling is actually possible
            const canScroll = thumbScroller.scrollHeight > thumbScroller.clientHeight;

            topArrow.style.display = (isAtTop || !canScroll) ? 'none' : 'flex';
            bottomArrow.style.display = (isAtBottom || !canScroll) ? 'none' : 'flex';
        };

        thumbScroller.addEventListener('scroll', updateThumbArrows);
        topArrow.addEventListener('click', () => thumbScroller.scrollBy({ top: -150, behavior: 'smooth' }));
        bottomArrow.addEventListener('click', () => thumbScroller.scrollBy({ top: 150, behavior: 'smooth' }));

        // Initial check and observers
        setTimeout(updateThumbArrows, 100);

        const resizeObserver = new ResizeObserver(() => {
            syncHeight();
            updateThumbArrows();
        });
        resizeObserver.observe(thumbScroller);
        resizeObserver.observe(mainPhotos);
    }
}

const isTest8 = document.querySelector('.test-8-variant');
if (isTest8) {
    new PDPFirstViewport8();
}
/***** Test 8 PDP First Viewport End ******/


/**** Test 11 Quick Add Start ******/
class QuickAddTest11 {
    constructor() {
        this.init();
    }

    init() {
        this.injectStyles();
        this.observeCards();

        // Handle dynamic product loading (e.g. infinite scroll)
        const gridObserver = new MutationObserver(() => {
            this.observeCards();
        });

        gridObserver.observe(document.body, { childList: true, subtree: true });
    }

    injectStyles() {
        if (document.getElementById('test-11-styles')) return;
        const style = document.createElement('style');
        style.id = 'test-11-styles';
        style.innerHTML = `
            /********** Test 11 Start **********/
            .test-11-variant-1 .grid-product__image-mask {
                position: relative;
                overflow: hidden;
            }
            .test-11-variant-1 .quick-product__btn {
                display: none !important;
            }
            .test-11-variant-1 .test-11-quick-add-btn {
                position: absolute;
                bottom: 0;
                right: 0;
                background: var(--color-grey-0, #010101);
                padding: 11.5px;
                width: 100%;
                transition: 0.5s ease;
                transform: translateY(25px);
                opacity: 0;
                pointer-events: none;
                color: #FFF;
                text-align: center;
                font-family: Barlow;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 20.8px;
                /* 130% */
                letter-spacing: 3.2px;
                text-transform: uppercase;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .test-11-variant-1 .test-11-btn-icon {
                display: none;
                align-items: center;
                justify-content: center;
            }
            .test-11-variant-1 .grid-product:hover .test-11-quick-add-btn {
                opacity: 1;
                pointer-events: visible;
                transform: none;
            }
            .test-11-variant-1 .test-11-quick-add-btn:hover {
                background: #333;
            }
            .test-11-variant-1 .test-11-spinner {
                display: none;
                width: 21px;
                height: 21px;
                border: 2px solid rgba(255,255,255,0.3);
                border-radius: 50%;
                border-top-color: #fff;
                animation: test-11-spin 1s ease-in-out infinite;
            }
            @keyframes test-11-spin {
                to { transform: rotate(360deg); }
            }
            .test-11-variant-1 .test-11-quick-add-btn.is-loading {
                pointer-events: none;
            }
            .test-11-variant-1 .test-11-quick-add-btn.is-loading .test-11-btn-text,
            .test-11-variant-1 .test-11-quick-add-btn.is-loading .test-11-btn-icon {
                display: none !important;
            }
            .test-11-variant-1 .test-11-quick-add-btn.is-loading .test-11-spinner {
                display: inline-block;
            }

            @media (max-width: 768px) {
                .test-11-variant-1 .test-11-quick-add-btn {
                    width: 36px;
                    height: 36px;
                    padding: 8px;
                    border-radius: 50%;
                    right: 10px;
                    bottom: 10px;
                    opacity: 1;
                    transform: none;
                    pointer-events: visible;
                }
                .test-11-variant-1 .test-11-quick-add-btn .test-11-btn-text {
                    display: none;
                }
                .test-11-variant-1 .test-11-quick-add-btn .test-11-btn-icon {
                    display: flex;
                }
            }
            /********** Test 11 End **********/
        `;
        document.head.appendChild(style);
    }

    observeCards() {
        const cards = document.querySelectorAll('.grid-product:not([data-test-11-initialized])');
        cards.forEach(card => {
            card.dataset.test11Initialized = "true";
            this.injectButton(card);
        });
    }

    injectButton(card) {
        const imageMask = card.querySelector('.grid-product__image-mask');
        if (!imageMask || imageMask.querySelector('.test-11-quick-add-btn')) return;

        const btn = document.createElement('button');
        btn.className = 'test-11-quick-add-btn';
        btn.innerHTML = `
            <span class="test-11-btn-text"></span>
            <span class="test-11-btn-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.4375 5.96563H18.0594L15.5781 13.9687H5.6125L2.59688 3H0" stroke="white" stroke-width="1.5"/>
                    <path d="M7.5 17.7031C7.84518 17.7031 8.125 17.4233 8.125 17.0781C8.125 16.7329 7.84518 16.4531 7.5 16.4531C7.15482 16.4531 6.875 16.7329 6.875 17.0781C6.875 17.4233 7.15482 17.7031 7.5 17.7031Z" fill="white" stroke="white" stroke-width="1.5"/>
                    <path d="M13.75 17.7031C14.0952 17.7031 14.375 17.4233 14.375 17.0781C14.375 16.7329 14.0952 16.4531 13.75 16.4531C13.4048 16.4531 13.125 16.7329 13.125 17.0781C13.125 17.4233 13.4048 17.7031 13.75 17.7031Z" fill="white" stroke="white" stroke-width="1.5"/>
                </svg>
            </span>
            <div class="test-11-spinner"></div>
        `;

        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.handleButtonClick(card, btn);
        });

        imageMask.appendChild(btn);

        this.updateButtonStateFromDOM(card, btn);
    }

    updateButtonStateFromDOM(card, btn) {
        const variantCount = parseInt(card.dataset.variantCount || '0', 10);
        const isAvailable = card.dataset.available === 'true';
        const url = card.dataset.productUrl || (card.querySelector('a') ? card.querySelector('a').href : '');
        const variantId = card.dataset.firstVariantId;

        const btnText = btn.querySelector('.test-11-btn-text');

        if (variantCount > 1) {
            btnText.textContent = 'View Product';
            btn.dataset.action = 'view';
            btn.dataset.url = url;
        } else {
            if (isAvailable) {
                btnText.textContent = '+ Quick Add';
                btn.dataset.action = 'add';
                btn.dataset.variantId = variantId;
            } else {
                btnText.textContent = 'Sold Out';
                btn.dataset.action = 'sold_out';
                btn.disabled = true;
                btn.style.cursor = 'not-allowed';
            }
        }
    }

    async handleButtonClick(card, btn) {
        const action = btn.dataset.action;

        if (action === 'view') {
            window.location.href = btn.dataset.url;
        } else if (action === 'add') {
            const variantId = btn.dataset.variantId;
            if (!variantId) return;

            btn.classList.add('is-loading');

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{ id: variantId, quantity: 1 }]
                    })
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                btn.classList.remove('is-loading');
                const text = btn.querySelector('.test-11-btn-text');
                text.textContent = 'Added!';

                setTimeout(() => {
                    if (btn) text.textContent = 'Add to Cart';
                }, 2000);

                // // Trigger standard Shopify theme events for cart update
                // document.dispatchEvent(new CustomEvent('cart:build'));
                // document.dispatchEvent(new CustomEvent('cart:refresh'));
                // document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

            } catch (error) {
                console.error('Error adding to cart:', error);
                btn.classList.remove('is-loading');
                const text = btn.querySelector('.test-11-btn-text');
                text.textContent = 'Error';
                setTimeout(() => {
                    if (btn) text.textContent = 'Add to Cart';
                }, 2000);
            }
        }
    }
}

const isTest11 = document.querySelector('.test-11-variant-1');
if (isTest11) {
    new QuickAddTest11();
}
/**** Test 11 Quick Add End *****/

/**** Test 14 Start *****/
class Test14Variant1 {
    constructor() {
        this.init();
    }

    init() {
        this.injectStyles();
        this.moveRecommendations();
        this.initQuickAdd();
    }

    injectStyles() {
        if (document.getElementById('test-14-styles')) return;
        const style = document.createElement('style');
        style.id = 'test-14-styles';
        style.innerHTML = `
            .test-14-variant-1 .product-recommendations .grid-product__image-mask,
            .test-14-variant-1 [id$="__product-recommendations"] .grid-product__image-mask {
                position: relative;
                overflow: hidden;
            }
            .test-14-variant-1 .product-recommendations .quick-product__btn,
            .test-14-variant-1 [id$="__product-recommendations"] .quick-product__btn {
                display: none !important;
            }
            .test-14-variant-1 .test-14-quick-add-btn {
                position: absolute;
                bottom: 0;
                right: 0;
                background: var(--color-grey-0, #010101);
                padding: 11.5px;
                width: 100%;
                transition: 0.5s ease;
                transform: translateY(25px);
                opacity: 0;
                pointer-events: none;
                color: #FFF;
                text-align: center;
                font-family: Barlow;
                font-size: 16px;
                font-weight: 500;
                line-height: 20.8px;
                letter-spacing: 3.2px;
                text-transform: uppercase;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 2;
                border: none;
                cursor: pointer;
            }
            .test-14-variant-1 .test-14-btn-icon {
                display: none;
                align-items: center;
                justify-content: center;
            }
            .test-14-variant-1 .grid-product:hover .test-14-quick-add-btn {
                opacity: 1;
                pointer-events: visible;
                transform: none;
            }
            .test-14-variant-1 .test-14-quick-add-btn:hover {
                background: #333;
            }
            .test-14-variant-1 .test-14-spinner {
                display: none;
                width: 21px;
                height: 21px;
                border: 2px solid rgba(255,255,255,0.3);
                border-radius: 50%;
                border-top-color: #fff;
                animation: test-14-spin 1s ease-in-out infinite;
            }
            @keyframes test-14-spin {
                to { transform: rotate(360deg); }
            }
            .test-14-variant-1 .test-14-quick-add-btn.is-loading {
                pointer-events: none;
            }
            .test-14-variant-1 .test-14-quick-add-btn.is-loading .test-14-btn-text,
            .test-14-variant-1 .test-14-quick-add-btn.is-loading .test-14-btn-icon {
                display: none !important;
            }
            .test-14-variant-1 .test-14-quick-add-btn.is-loading .test-14-spinner {
                display: inline-block;
            }

            @media (max-width: 768px) {
                .test-14-variant-1 .test-14-quick-add-btn {
                    width: 36px;
                    height: 36px;
                    padding: 8px;
                    border-radius: 50%;
                    right: 10px;
                    bottom: 10px;
                    opacity: 1;
                    transform: none;
                    pointer-events: visible;
                }
                .test-14-variant-1 .test-14-quick-add-btn .test-14-btn-text {
                    display: none;
                }
                .test-14-variant-1 .test-14-quick-add-btn .test-14-btn-icon {
                    display: flex;
                }
            }
        `;
        document.head.appendChild(style);
    }

    moveRecommendations() {
        this.pollAttempts = 0;
        const interval = setInterval(() => {
            this.pollAttempts++;
            if (this.pollAttempts > 20) {
                clearInterval(interval);
                return;
            }

            const recommendationsSection = document.querySelector('[id*="__product-recommendations"]')
            const reviewsSection = document.querySelector('.product-section + .yotpo-widget-instance');

            if (recommendationsSection && reviewsSection && !recommendationsSection.dataset.moved) {
                reviewsSection.parentNode.insertBefore(recommendationsSection, reviewsSection);
                recommendationsSection.dataset.moved = "true";
                clearInterval(interval);
            }
        }, 500);
    }

    initQuickAdd() {
        const observer = new MutationObserver(() => {
            this.observeCards();
        });

        observer.observe(document.body, { childList: true, subtree: true });
        this.observeCards();
    }

    observeCards() {
        const recommendationsSection = document.querySelector('.product-recommendations') || document.querySelector('[id$="__product-recommendations"]');
        if (!recommendationsSection) return;

        const cards = recommendationsSection.querySelectorAll('.grid-product:not([data-test-14-initialized])');
        cards.forEach(card => {
            card.dataset.test14Initialized = "true";
            this.injectButton(card);
        });
    }

    injectButton(card) {
        const imageMask = card.querySelector('.grid-product__image-mask');
        if (!imageMask || imageMask.querySelector('.test-14-quick-add-btn')) return;

        const btn = document.createElement('button');
        btn.className = 'test-14-quick-add-btn';
        btn.innerHTML = `
            <span class="test-14-btn-text"></span>
            <span class="test-14-btn-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.4375 5.96563H18.0594L15.5781 13.9687H5.6125L2.59688 3H0" stroke="white" stroke-width="1.5"/>
                    <path d="M7.5 17.7031C7.84518 17.7031 8.125 17.4233 8.125 17.0781C8.125 16.7329 7.84518 16.4531 7.5 16.4531C7.15482 16.4531 6.875 16.7329 6.875 17.0781C6.875 17.4233 7.15482 17.7031 7.5 17.7031Z" fill="white" stroke="white" stroke-width="1.5"/>
                    <path d="M13.75 17.7031C14.0952 17.7031 14.375 17.4233 14.375 17.0781C14.375 16.7329 14.0952 16.4531 13.75 16.4531C13.4048 16.4531 13.125 16.7329 13.125 17.0781C13.125 17.4233 13.4048 17.7031 13.75 17.7031Z" fill="white" stroke="white" stroke-width="1.5"/>
                </svg>
            </span>
            <div class="test-14-spinner"></div>
        `;

        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.handleButtonClick(card, btn);
        });

        imageMask.appendChild(btn);
        this.updateButtonStateFromDOM(card, btn);
    }

    updateButtonStateFromDOM(card, btn) {
        const variantCount = parseInt(card.dataset.variantCount || '0', 10);
        const isAvailable = card.dataset.available === 'true';
        const url = card.dataset.productUrl || (card.querySelector('a') ? card.querySelector('a').href : '');
        const variantId = card.dataset.firstVariantId;

        const btnText = btn.querySelector('.test-14-btn-text');

        if (variantCount > 1) {
            btnText.textContent = 'View Product';
            btn.dataset.action = 'view';
            btn.dataset.url = url;
        } else {
            if (isAvailable) {
                btnText.textContent = '+ Quick Add';
                btn.dataset.action = 'add';
                btn.dataset.variantId = variantId;
            } else {
                btnText.textContent = 'Sold Out';
                btn.dataset.action = 'sold_out';
                btn.disabled = true;
                btn.style.cursor = 'not-allowed';
            }
        }
    }

    async handleButtonClick(card, btn) {
        const action = btn.dataset.action;

        if (action === 'view') {
            window.location.href = btn.dataset.url;
        } else if (action === 'add') {
            const variantId = btn.dataset.variantId;
            if (!variantId) return;

            btn.classList.add('is-loading');

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{ id: variantId, quantity: 1 }]
                    })
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                btn.classList.remove('is-loading');
                const text = btn.querySelector('.test-14-btn-text');
                text.textContent = 'Added!';

                setTimeout(() => {
                    if (btn) text.textContent = '+ Quick Add';
                }, 2000);

            } catch (error) {
                console.error('Error adding to cart:', error);
                btn.classList.remove('is-loading');
                const text = btn.querySelector('.test-14-btn-text');
                text.textContent = 'Error';
                setTimeout(() => {
                    if (btn) text.textContent = '+ Quick Add';
                }, 2000);
            }
        }
    }
}

const isTest14 = document.querySelector('.test-14-variant-1');
if (isTest14) {
    new Test14Variant1();
}
/**** Test 14 End *****/

/**** Test 15 Start *****/
class Test15Variant {
    constructor() {
        this.init();
    }

    init() {
        this.injectStyles();
        this.createModal();
        this.attachEventListeners();
    }

    injectStyles() {
        if (document.getElementById('test-15-styles')) return;
        const style = document.createElement('style');
        style.id = 'test-15-styles';
        style.innerHTML = `
            .test-15-variant-1 .test-15-modal {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                max-width: 100%;
                max-height: 100%;
                margin: 0;
                padding: 0;
                border: none;
                background: transparent;
                z-index: 99999;
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.3s ease;
            }
            .test-15-variant-1 .test-15-modal nav.breadcrumb {
                display: none;
            }
                .test-15-variant-1 .test-15-modal  button.btn.btn--body.btn--circle.js-photoswipe__zoom{
                    pointer-events: none !important;
                }

            .test-15-variant-1 .test-15-modal .product-block.product-block--header {
                margin-bottom: 0;
            }

            .test-15-variant-1 .test-15-modal .product__policies.rte.small--text-center {
                display: none;
            }

            .test-15-variant-1 .test-15-modal .add-to-cart.btn--secondary {
                background: #000;
                color: #fff;
                transition: 0.5s ease;
            }

            .test-15-variant-1 .test-15-modal .add-to-cart.btn--secondary:hover {
                background: #333;
            }

            .test-15-variant-1 .test-15-modal #more-payment-options-link {
                display: none;
            }

            .test-15-variant-1 .test-15-modal .product-block.product-block--tab {
                display: none;
            }

            .test-15-variant-1 .test-15-modal .product__main-photos .flickity-page-dots {
                display: block;
            }

            .test-15-variant-1 .test-15-modal .product__thumbs {
                display: none;
            }

            .test-15-variant-1 .test-15-modal::backdrop {
                background: transparent;
            }
            .test-15-variant-1 .test-15-modal[open] {
                display: flex;
            }
            .test-15-variant-1 .test-15-modal.is-open {
                opacity: 1;
                pointer-events: auto;
            }
            .test-15-variant-1 .test-15-modal-backdrop {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, .5);
                position: fixed;
            }

            .test-15-open-modal .unicorn_backdrop {
                display: none !IMPORTANT;
            }
            .test-15-variant-1 .test-15-modal-content {
                position: relative;
                background: var(--color-body, #fff);
                width: 90%;
                max-width: 1100px;
                max-height: 90vh;
                overflow-y: auto;
                border-radius: 5px;
                box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                transform: translateY(20px);
                transition: 0.3s ease;
                display: flex;
                flex-direction: column;
            }
            .test-15-variant-1 .test-15-modal.is-open .test-15-modal-content {
                transform: translateY(0);
            }
            .test-15-variant-1 .test-15-spinner {
                display: none;
                width: 40px;
                height: 40px;
                border: 4px solid rgba(0,0,0,0.1);
                border-left-color: #000;
                border-radius: 50%;
                animation: test-15-spin 1s linear infinite;
                margin: 50px auto;
            }
            .test-15-variant-1 .test-15-modal.is-loading .test-15-spinner {
                display: block;
            }
            .test-15-variant-1 .test-15-modal.is-loading .test-15-modal-body {
                display: none;
            }
            @keyframes test-15-spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            .test-15-variant-1 .test-15-view-full-link {
                display: block;
                text-align: center;
                margin-top: 15px;
                text-decoration: underline;
                font-size: 14px;
                color: inherit;
            }
            /* Slide up for mobile */


            .test-15-variant-1 .test-15-modal [id*="yotpo_product_reviews_star_rating"] + .product-block {
                display: none;
            }

            .test-15-variant-1 .test-15-modal .product-block.product-block--price {
                margin: 14px 0 12px;
            }

            .test-15-variant-1 .test-15-modal square-placement {
                margin: 0;
            }

            .test-15-variant-1 .test-15-modal div#yotpo-reviews-star-ratings-widget {
                margin: 0 !important;
            }

           .test-15-variant-1 .test-15-modal h1.h2.product-single__title {
                margin-bottom: 14px;
                padding-right: 30px;
            }

            .test-15-variant-1 .test-15-modal .product-block:empty {
                display: none;
            }

            .test-15-variant-1 .test-15-modal .product-block.form-block {
                margin-top: auto;
            }

            .test-15-variant-1 .test-15-modal .product-block.form-block {
                display: none;
            }

            .test-15-variant-1 .test-15-modal .grid.grid--product-images--partial {
                display: flex;
                align-items: stretch;
            }

            .test-15-variant-1 .test-15-modal .product-single__meta {
                height: 100%;
                display: flex;
                flex-direction: column;
                padding-left: 16px;
            }

            .test-15-variant-1 .test-15-modal .test-16-modal-desktop-footer {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 20px 0 0;
                border-top: 1px solid black;
                margin-top: auto;
            }

            .test-15-variant-1 .test-15-modal a.test-16-view-full-product {
                color: var(--color-black-solid, #000);
                text-align: center;
                font-family: Barlow;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
                line-height: 25.2px; /* 180% */
                letter-spacing: 0.828px;
                text-decoration: underline;
            }

            .test-15-variant-1 .test-15-modal button.test-16-back-to-cart {
                color: #FFF;
                text-align: center;
                font-family: Barlow;
                font-size: 13px;
                font-style: normal;
                font-weight: 700;
                line-height: 18.46px; /* 142% */
                letter-spacing: 3.9px;
                text-transform: uppercase;
                background: #000;
                padding: 15px 43.5px;
            }

            .test-15-variant-1 .test-15-modal .test-15-mobile-header {
                padding: 0;
            }

            .test-15-variant-1 .test-15-modal p.test-15-modal-heading {
                display: none;
                color: #000;
                text-align: center;
                font-family: "Fjalla One";
                font-size: 20px;
                font-style: normal;
                font-weight: 400;
                line-height: 19.2px;
                letter-spacing: 2.4px;
                text-transform: uppercase;
                margin: 0;
            }

            .test-15-variant-1 .test-15-modal button.test-15-modal-close {
                position: absolute;
                background: none;
                border: none;
                font-size: 24px;
                cursor: pointer;
                z-index: 10;
                padding: 5px;
                line-height: 1;
                top: 42px !important;
                right: 32.5px;
            }

            .test-15-variant-1 .test-15-modal .page-content.page-content--product {
                padding: 42px 0;
            }

            .test-15-variant-1 .test-15-modal .page-width {
                padding: 0 20px 0 32px;
            }

            @media (max-width: 768px) {
                .test-15-variant-1 .test-15-modal {
                    align-items: flex-end;
                }
                .test-15-variant-1 .test-15-modal-content {
                    width: 100%;
                    max-width: 100%;
                    max-height: 90vh;
                    transform: translateY(100%);
                    border-radius: 0 !important;
                }
                .test-15-variant-1 .test-15-modal-content.is-expanded {
                    height: 100vh;
                    max-height: 100vh;
                }

                .test-15-variant-1 .test-15-modal .test-15-mobile-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 18px 16px 14px;
                    border-bottom: 1px solid #999;
                    position: sticky;
                    top: 0;
                    z-index: 99999;
                    background: #fff;
                }

                .test-15-variant-1 .test-15-modal p.test-15-modal-heading {
                    display: block;
                }

                .test-15-variant-1 .test-15-modal .test-15-modal-close {
                    position: static !important;
                }

                .test-15-variant-1 .test-15-modal .page-content.page-content--product {
                    padding: 0;
                }

                .test-15-variant-1 .test-15-modal .page-width {
                    padding: 0;
                }

                .test-15-variant-1 .test-15-modal .grid.grid--product-images--partial {
                    flex-direction: column;
                }

                .test-15-variant-1 .test-15-modal h1.h2.product-single__title {
                    padding: 10px 0 20px;
                    margin-bottom: 0;
                }

                .test-15-variant-1 .test-15-modal .product-single__meta {
                    padding: 0 16px;
                    margin-top: 16px;
                }

                .test-15-variant-1 .test-15-modal .test-16-modal-desktop-footer {
                    display: none;
                }

                .test-15-variant-1 .test-15-modal .product-block.form-block {
                    display: block;
                    margin-top: 24.5px;
                }

                .shopify-payment-button {
                    display: none;
                }

                .test-15-variant-1 .test-15-modal square-placement {
                    max-width: 293px;
                    margin: auto;
                }

                .test-15-variant-1 .test-15-view-full-link {
                    color: var(--color-black-solid, #000);
                    text-align: center;
                    font-family: Barlow;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 25.2px;
                    letter-spacing: 0.828px;
                }
            }
        `;
        document.head.appendChild(style);
    }

    createModal() {
        if (document.querySelector('.test-15-modal')) return;

        const modal = document.createElement('dialog');
        modal.className = 'test-15-modal';
        modal.innerHTML = `
            <div class="test-15-modal-backdrop"></div>
            <div class="test-15-modal-content">
            <div class="test-15-mobile-header"><p class="test-15-modal-heading">QUICK VIEW</p> <button class="test-15-modal-close"><svg class="" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.12489 0C0.836894 0 0.549422 0.109652 0.329485 0.32959C-0.109828 0.768902 -0.109828 1.4811 0.329485 1.92041L8.53407 10.125L0.329485 18.3296C-0.109828 18.7689 -0.109828 19.4811 0.329485 19.9204C0.549422 20.1403 0.836894 20.25 1.12489 20.25C1.41289 20.25 1.70037 20.1403 1.9203 19.9204L10.1249 11.7158L18.3295 19.9204C18.7688 20.3597 19.481 20.3597 19.9203 19.9204C20.3596 19.4811 20.3596 18.7689 19.9203 18.3296L11.7157 10.125L19.9203 1.92041C20.3596 1.4811 20.3596 0.768903 19.9203 0.32959C19.481 -0.109722 18.7688 -0.109722 18.3295 0.32959L10.1249 8.53418L1.9203 0.32959C1.70037 0.109653 1.41289 0 1.12489 0Z" fill="black"></path>
                </svg></button>
            </div>
                <div class="test-15-spinner"></div>
                <div class="test-15-modal-body"></div>
            </div>
        `;

        document.body.appendChild(modal);

        modal.querySelector('.test-15-modal-backdrop').addEventListener('click', () => this.closeModal());
        modal.querySelector('.test-15-modal-close').addEventListener('click', () => this.closeModal());

        const modalContent = modal.querySelector('.test-15-modal-content');
        modalContent.addEventListener('scroll', function() {
            if (window.innerWidth <= 768) {
                if (this.scrollTop > (this.scrollHeight * 0.15)) {
                    this.classList.add('is-expanded');
                } else {
                    this.classList.remove('is-expanded');
                }
            }
        });
    }

    attachEventListeners() {
        document.body.addEventListener('click', (e) => {
            const link = e.target.closest('a[href*="/products/"]');
            if (!link) return;

            const cartContainer = e.target.closest('#unicorn-cart-dialog');
            if (cartContainer) {
                e.preventDefault();
                this.openModal(link.href);
            }
        });
    }

    async openModal(productUrl) {
        const modal = document.querySelector('.test-15-modal');
        const modalBody = modal.querySelector('.test-15-modal-body');
        document.querySelector('body').classList.add('test-15-open-modal');

        if (typeof modal.showModal === 'function' && !modal.open) {
            modal.showModal();
        }

        modal.classList.add('is-open', 'is-loading');
        modalBody.innerHTML = '';

        try {
            const response = await fetch(productUrl);
            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const productSection = doc.querySelector('.product-section');
            if (productSection) {
                productSection.classList.add('aos-animate')
                // Remove loading state before inserting so Flickity can calculate height
                modal.classList.remove('is-loading');

                productSection.querySelector('.product-single__form').closest('.product-block').closest('.product-block').classList.add('form-block')
                const idElements = productSection.querySelectorAll('[id]');
                idElements.forEach(el => {
                    const oldId = el.id;
                    const newId = oldId + '-test16';
                    el.id = newId;

                    productSection.querySelectorAll(`[aria-controls="${oldId}"]`).forEach(ctrl => ctrl.setAttribute('aria-controls', newId));
                    productSection.querySelectorAll(`[data-controls="${oldId}"]`).forEach(ctrl => ctrl.setAttribute('data-controls', newId));
                    productSection.querySelectorAll(`[data-id="${oldId}"]`).forEach(ctrl => ctrl.setAttribute('data-id', newId));
                    productSection.querySelectorAll(`[for="${oldId}"]`).forEach(lbl => lbl.setAttribute('for', newId));
                });

                const addToCartBtns = productSection.querySelectorAll('button.add-to-cart, button[name="add"]');
                addToCartBtns.forEach(btn => {
                    const span = btn.querySelector('span[data-add-to-cart-text]');
                    if (span) {
                        span.textContent = 'Update Product';
                    } else {
                        btn.textContent = 'Update Product';
                    }

                    const link = document.createElement('a');
                    link.href = productUrl;
                    link.className = 'test-15-view-full-link';
                    link.textContent = 'View Full Product';

                    const paymentTerms = productSection.querySelector('.shopify-payment-button') || btn;
                    paymentTerms.parentNode.insertBefore(link, paymentTerms.nextSibling);
                });

                this.createDesktopModalFooter(productUrl, productSection);
                modalBody.appendChild(productSection);

                if (window.theme && theme.sections) {
                    theme.sections.register('product', theme.Product, modalBody);
                }

                modalBody.querySelector('.test-16-back-to-cart').addEventListener('click', () => this.closeModal());
             
                    if(yotpoWidgetsContainer && yotpoWidgetsContainer.initWidgets){
                        yotpoWidgetsContainer.initWidgets();
                        // iF no reviews after this, there are no reviews:
                        setTimeout(()=>{
                            if(!modalBody.querySelector('.yotpo-widget-instance').querySelector('.yotpo-reviews-star-ratings-widget')){
                                // No reviews:
                                modalBody.querySelector('.yotpo-widget-instance').innerHTML = `<div class="yotpo-reviews-star-ratings-widget yotpo-star-ratings-widget-override-css yotpo-device-desktop yotpo-display-l" id="yotpo-reviews-star-ratings-widget" style="display: flex; justify-content: left; flex-direction: row; margin-bottom: 5px;">
                                    <div class="yotpo-widget-clear yotpo-bottom-line-scroll-panel" style="display: flex; align-items: flex-start; flex-flow: column wrap;">
                                    <div style="display: none;"></div>

                                    <button class="yotpo-sr-bottom-line-summary yotpo-sr-bottom-line-button" type="button" aria-label="0 out of 5 stars rating in total 0 reviews. Jump to reviews." style="display: flex; flex-direction: row; align-items: flex-start; direction: ltr; cursor: pointer;">
                                <span style="display: flex; cursor: pointer;">
                                    <span aria-hidden="true" style="display: flex; flex-direction: row; align-items: center; height: 28px; cursor: pointer;">
                                <svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-full" width="15" height="15" style="display: flex; flex-direction: row; margin-inline-end: 3.5px;">
                                    <defs>
                                        <linearGradient id="yotpo_stars_gradient_0.11661508589643943">
                                            <stop offset="100%" stop-color="#FFDD00"></stop>
                                            <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
                                        </linearGradient>
                                    </defs>
                                    <path style="fill: none;pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#FFDD00" fill="url('#yotpo_stars_gradient_0.11661508589643943')"></path>
                                </svg><svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-full" width="15" height="15" style="display: flex; flex-direction: row; margin-inline-end: 3.5px;">
                                    <defs>
                                        <linearGradient id="yotpo_stars_gradient_0.645728842844497">
                                            <stop offset="100%" stop-color="#FFDD00"></stop>
                                            <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
                                        </linearGradient>
                                    </defs>
                                    <path style="pointer-events: none;fill: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#FFDD00" fill="url('#yotpo_stars_gradient_0.645728842844497')"></path>
                                </svg><svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-full" width="15" height="15" style="display: flex; flex-direction: row; margin-inline-end: 3.5px;">
                                    <defs>
                                        <linearGradient id="yotpo_stars_gradient_0.09057336266400084">
                                            <stop offset="100%" stop-color="#FFDD00"></stop>
                                            <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
                                        </linearGradient>
                                    </defs>
                                    <path style="pointer-events: none;fill: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#FFDD00" fill="url('#yotpo_stars_gradient_0.09057336266400084')"></path>
                                </svg><svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-full" width="15" height="15" style="display: flex;flex-direction: row;margin-inline-end: 3.5px;">
                                    <defs>
                                        <linearGradient id="yotpo_stars_gradient_0.27540136728301756">
                                            <stop offset="100%" stop-color="#FFDD00"></stop>
                                            <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
                                        </linearGradient>
                                    </defs>
                                    <path style="pointer-events: none;fill: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#FFDD00" fill="url('#yotpo_stars_gradient_0.27540136728301756')"></path>
                                </svg><svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-full" width="15" height="15" style="display: flex; flex-direction: row; margin-inline-end: 8px;">
                                    <defs>
                                        <linearGradient id="yotpo_stars_gradient_0.7720052556554121">
                                            <stop offset="100%" stop-color="#FFDD00"></stop>
                                            <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
                                        </linearGradient>
                                    </defs>
                                    <path style="pointer-events: none;fill: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#FFDD00" fill="url('#yotpo_stars_gradient_0.7720052556554121')"></path>
                                </svg>
                            </span>
                                    <!--v-if-->
                                </span>
                                <!--v-if-->
                                    <span class="yotpo-sr-bottom-line-right-panel" style="display: flex;">
                                    <span class="yotpo-sr-bottom-line-text yotpo-sr-bottom-line-text--right-panel" style="white-space: nowrap; font-size: 16px; text-align: start; font-family: &quot;Nunito Sans&quot;; font-style: normal; font-weight: 700; color: rgb(44, 44, 44); padding-top: 2px; line-height: 28px;">No Reviews</span>
                                    </span>
                                <!--v-if-->
                            </button>
                            <!--v-if-->
                            <!--v-if-->
                            <!--v-if-->
                            <!--v-if-->
                            <!--v-if-->
                            <!--v-if-->
                        </div>
                    </div>`;
                        }
                     },1000)
                }
            } else {
                modal.classList.remove('is-loading');
                modalBody.innerHTML = '<p style="padding: 20px; text-align: center;">Product could not be loaded.</p>';
            }
        } catch (error) {
            console.error('Error fetching product for quick view:', error);
            modal.classList.remove('is-loading');
            modalBody.innerHTML = '<p style="padding: 20px; text-align: center;">Error loading product.</p>';
        }
    }

    createDesktopModalFooter(productUrl,productSection){
        const div = document.createElement('div');
        div.innerHTML = `<div class="test-16-modal-desktop-footer">
            <a class="test-16-view-full-product" href="${productUrl}">View Full Product</a>
            <button class="test-16-back-to-cart">BACK TO CART</button>
        </div>`
        productSection.querySelector('.product-single__meta').appendChild(div.querySelector('.test-16-modal-desktop-footer'))
    }
    closeModal() {
        const modal = document.querySelector('.test-15-modal');
        if (modal) {
            modal.classList.remove('is-open');
            document.querySelector('body').classList.remove('test-15-open-modal');
            setTimeout(() => {
                if (typeof modal.close === 'function') {
                    modal.close();
                }
                modal.querySelector('.test-15-modal-body').innerHTML = '';
            }, 300);
        }
    }
}

const isTest15 = document.querySelector('.test-15-variant-1');
if (isTest15) {
    new Test15Variant();
}
/**** Test 15 End *****/
